import { CLINICAL_BASE_PATH } from '../constants';

export const BASE_DATA_EXPORTS_PATH = `${CLINICAL_BASE_PATH}/data-exports`;

export const POPULATIONS_DATA_EXPORTS_BASE_PATH = `${BASE_DATA_EXPORTS_PATH}/populations`;
export const POPULATIONS_DATA_EXPORTS_DETAIL_PATH = `${POPULATIONS_DATA_EXPORTS_BASE_PATH}/:id`;
